<template>
    <div v-clickoutside="changeShow" @mouseleave="changeShow" class="cont-right-one select-box" id="defaultSelect" :class="selectBoxClass" @click="selectShowFunction" @click.stop="showData()" ref="sel">
        <div class="select-input">
            <div class="select-title" v-if="title">{{title}}</div>
            <span>{{selectOption.length>0?selectOption[currentIndex-1].name:""}}</span>
            <div class="icon-util" :class="dropDownName" style="float: right;"></div>
        </div>
        <div class="select-value" v-show="selectShow&&selectOption.length" id="selectValue" ref="selectValueWidth">
            <div :key=index @click="changSelectValue(item,index)" v-for="(item,index) in selectOption">
                <div class="select-value-option" v-if="item.id!=currentIndex||!checkRemove">
                    <div class="select-title" v-if="title"><div class="icon-util tick-blue f-hide"></div></div>
                    {{item.name}}
                    <div v-if="item.icon==true" class="icon-util vip select-vip-position"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            selectShow: false,
            selectBoxClass: '',
            dropDownName: 'drop-down',
            currentIndex: this.selectId,
            maxValue: 0,
            listNormalOpen:false
        }
    },
    watch: {
        currentIndex(newId, oldId) {
            this.$emit('changeOption', newId);
        }
    },
    props: {
        selectOption: {
            type: Array,
            default () {
                return []
            }
        },
        selectId: {
            type: Number
        },
        title: {
            type: String
        },
        checkRemove: {
            type: Boolean
        }
    },
    mounted() {
    },
    methods: {
        showData(){
            this.selectShow=!this.selectShow;
        },
        selectShowFunction() { //选中选项时控制下拉框的
            if (this.selectShow) {
                this.selectBoxClass = '';
                this.dropDownName = 'drop-down';
            } else {
                this.selectBoxClass = 'select-box-click';
                this.dropDownName = 'drop-down-up';
            }
        },
        //用户点击一个选项
        changSelectValue(event, index) {
            this.currentIndex = event.id;
            this.selectShowFunction();
            this.$emit('chickOption', event.id);
        },
        changeShow() {
            this.selectShow = false;
            this.selectBoxClass = '';
            this.dropDownName = 'drop-down';
        }
    }
}
</script>

<style scoped>
/*设置下拉框样式*/
.select-box {
    width: fit-content;
    height: 34px;
    /*no*/
    border: 1px solid #E0EAF9;
    /*no*/
    outline: none;
    box-sizing: border-box;
    background-color: transparent;
    padding-left: 10px;
    /*no*/
    line-height: 34px;
    /*no*/
    font-size: 14px;
    /*no*/
    background: #FFF;
}

.select-box-click {
    border: 1px solid #8A96E3;
    /*no*/
}

.select-value {
    position: absolute;
    z-index: 300;
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #8A96E3;
    /*no*/
    background: #FFF;
    left: -1px;
    /*no*/
    top: 33px;
    /*no*/
    width: -webkit-fill-available;
}

.select-value-option {
    width: 100%;
    height: 33px;
    /*no*/
    line-height: 34px;
    /*no*/
    padding: 0px 10px 0px 10px;
    /*no*/
    box-sizing: border-box;
    white-space: nowrap;
     cursor: pointer;
}

.select-value-option:hover {
    background-color: #EBF3FE;

}

.select-value-option .select-title {
    color:#ffffff;
    height: inherit;
}

.select-value-option:hover .select-title {
    color:#EBF3FE;
}

.select-vip-position {
    position: relative;
    top: 26%;
    float: right;
}

.cont-right-one {
    min-width: 350px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    position: relative;
}

.select-none-div{
    width: 100%;
    height: 34px;
    /*no*/
    line-height: 34px;
    /*no*/
    padding: 0px 10px 0px 10px;
    /*no*/
    box-sizing: border-box;
    white-space: nowrap;
    cursor: default;
}

.select-title {
    float: left;
    margin-right: 10px;/*no*/
    text-align: center;
    width: 55px;/*no*/
}

.select-title .icon-util{
    margin-top: 10px;/*no*/
}

.select-value-option:hover .f-hide {
    display: inline-block;
}

.select-input {
    font-size: 14px;/*no*/
    font-family: Arial;
    font-weight: 400;
    line-height: 34px;/*no*/
    color: #000000;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/default_select.vue